import { createBrowserRouter } from "react-router-dom";
import { Layout } from "src/componentes";
import { Duvidas } from "src/paginas/duvidas/Duvidas.page";
import { Home } from "src/paginas/home/Home.page";
import { Politica } from "src/paginas/politica/Politica.page";
import { Termos } from "src/paginas/termos/Termos.page";

export const browserRouter = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      { path: "/home", element: <Home /> },
      { path: "/faq", element: <Duvidas /> },
      { path: "*", element: <Home /> },
    ],
  },
  { path: "politica", element: <Politica /> },
  { path: "termos", element: <Termos /> },
]);
